import React, { useState } from 'react';
import { ChevronRight, ChevronDown, Plus, Edit, Trash2 } from 'lucide-react';
import Card from '../../components/ui/Card';
import Button from '../../components/ui/Button';
import Badge from '../../components/ui/Badge';
import Modal from '../../components/ui/Modal';
import Input from '../../components/ui/Input';
import { useToast } from '../../components/ui/Toast';
import { categories } from '../../data/mockData';

function CategoryNode({ cat, children, depth = 0 }) {
  const [open, setOpen] = useState(depth === 0);
  const toast = useToast();
  const hasChildren = children && children.length > 0;

  return (
    <div>
      <div style={{
        display: 'flex', alignItems: 'center', gap: 8,
        padding: `10px ${12 + depth * 20}px`,
        borderBottom: '1px solid #F3F4F6',
        transition: 'background 0.12s',
      }}
        onMouseEnter={e => e.currentTarget.style.background = '#F8F9FB'}
        onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
        <button onClick={() => setOpen(o => !o)} style={{
          display: 'flex', alignItems: 'center', background: 'none', border: 'none', cursor: hasChildren ? 'pointer' : 'default',
          color: '#6B7280', padding: 2,
        }}>
          {hasChildren ? (open ? <ChevronDown size={14} /> : <ChevronRight size={14} />) : <span style={{ width: 14 }} />}
        </button>
        <span style={{ fontSize: 18 }}>{cat.icon}</span>
        <span style={{ fontWeight: depth === 0 ? 700 : 500, fontSize: depth === 0 ? 14 : 13, color: '#1A1A2E', flex: 1 }}>{cat.name}</span>
        <Badge variant="gray">{cat.productCount} товаров</Badge>
        <div style={{ display: 'flex', gap: 6, marginLeft: 8 }}>
          <button onClick={() => toast('Редактирование категории', 'success')} style={{ padding: '4px 8px', border: '1px solid #E5E7EB', borderRadius: 6, background: '#fff', cursor: 'pointer', color: '#6B7280', display: 'flex', alignItems: 'center' }}>
            <Edit size={13} />
          </button>
          {depth > 0 && <button onClick={() => toast('Категория удалена', 'warning')} style={{ padding: '4px 8px', border: '1px solid #FEE2E2', borderRadius: 6, background: '#FFF0F0', cursor: 'pointer', color: '#FF3B30', display: 'flex', alignItems: 'center' }}>
            <Trash2 size={13} />
          </button>}
          <button onClick={() => toast('Подкатегория создана', 'success')} style={{ padding: '4px 8px', border: '1px solid #E5E7EB', borderRadius: 6, background: '#fff', cursor: 'pointer', color: '#4A6CF7', display: 'flex', alignItems: 'center' }}>
            <Plus size={13} />
          </button>
        </div>
      </div>
      {open && hasChildren && children.map(ch => (
        <CategoryNode key={ch.id} cat={ch} depth={depth + 1}
          children={categories.filter(c => c.parentId === ch.id)} />
      ))}
    </div>
  );
}

export default function ProductCategories() {
  const toast = useToast();
  const [showModal, setShowModal] = useState(false);
  const [form, setForm] = useState({ name: '', icon: '📦' });
  const rootCats = categories.filter(c => !c.parentId);

  const totalProducts = categories.filter(c => !c.parentId).reduce((a, c) => a + c.productCount, 0);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div>
          <h1 style={{ fontSize: 22, fontWeight: 800, color: '#1A1A2E' }}>Категории / Иерархия FMCG</h1>
          <p style={{ color: '#8E8E93', fontSize: 13, marginTop: 2 }}>Всего: {rootCats.length} категорий • {totalProducts} товаров</p>
        </div>
        <Button icon={<Plus size={14} />} onClick={() => setShowModal(true)}>Добавить категорию</Button>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(140px, 1fr))', gap: 12 }}>
        {rootCats.map(c => (
          <div key={c.id} style={{ background: '#fff', borderRadius: 12, padding: '16px 14px', textAlign: 'center', border: '1px solid #F0F0F0', boxShadow: '0 1px 3px rgba(0,0,0,0.06)' }}>
            <div style={{ fontSize: 30, marginBottom: 6 }}>{c.icon}</div>
            <div style={{ fontWeight: 700, fontSize: 13, color: '#1A1A2E', marginBottom: 2 }}>{c.name}</div>
            <div style={{ fontSize: 12, color: '#8E8E93' }}>{c.productCount} товаров</div>
          </div>
        ))}
      </div>

      <Card title="Дерево категорий FMCG" padding="0">
        {rootCats.map(cat => (
          <CategoryNode key={cat.id} cat={cat} depth={0}
            children={categories.filter(c => c.parentId === cat.id)} />
        ))}
      </Card>

      <Modal open={showModal} onClose={() => setShowModal(false)} title="Добавить категорию">
        <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
          <Input label="Название категории" value={form.name} onChange={e => setForm(f => ({ ...f, name: e.target.value }))} placeholder="Молочные" required />
          <Input label="Иконка (emoji)" value={form.icon} onChange={e => setForm(f => ({ ...f, icon: e.target.value }))} placeholder="🥛" />
          <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end', marginTop: 8 }}>
            <Button variant="secondary" onClick={() => setShowModal(false)}>Отмена</Button>
            <Button onClick={() => { toast('Категория создана', 'success'); setShowModal(false); }}>Создать</Button>
          </div>
        </div>
      </Modal>
    </div>
  );
}
